/**
 * ToolTimeline - Vertical timeline display of tool calls.
 *
 * Shows all tool calls in sequence with connecting lines
 * and status indicators.
 */

import { Wrench } from 'lucide-react'
import { ToolTimelineItem } from './ToolTimelineItem'
import type { ToolCall } from '@/store/chatStore'

interface ToolTimelineProps {
  toolCalls: ToolCall[]
  isStreaming?: boolean
}

export function ToolTimeline({ toolCalls, isStreaming = false }: ToolTimelineProps) {
  if (toolCalls.length === 0) return null

  return (
    <div className="space-y-2">
      {/* Header */}
      <div className="flex items-center gap-2 text-xs text-text-muted">
        <Wrench className="w-3 h-3" />
        <span>
          {toolCalls.length} tool{toolCalls.length > 1 ? 's' : ''}{' '}
          {isStreaming ? 'in progress' : 'used'}
        </span>
      </div>

      {/* Timeline */}
      <div className="space-y-1.5">
        {toolCalls.map((tc, i) => (
          <ToolTimelineItem
            key={`${tc.name}-${i}`}
            toolCall={tc}
            isStreaming={isStreaming && tc.status === 'running'}
            showConnector={i > 0}
          />
        ))}
      </div>
    </div>
  )
}

export default ToolTimeline
